import React from 'react';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';

const haveFiles = (file) => {
  if (file === null) {
    return true;
  }
  return file;
};

export default Yup.object().shape({
  information: Yup.boolean().oneOf(
    [true],
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  first_identity: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  first_identity_number: Yup.string()
    .matches(/^[A-Za-z]{2}\d{6}$/, {
      message: (
        <FormattedMessage
          id="onboarding_identity_documents_form_identity_number_error"
          defaultMessage={dlt['onboarding_identity_documents_form_identity_number_error']}
        />
      ),
    })
    .required(
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />
    ),
  first_identity_image_front: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),
  first_identity_image_back: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),

  second_identity: Yup.string().required(
    <span style={{ marginTop: '15px' }}>
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />
    </span>
  ),
  second_identity_number: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  second_identity_image_front: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),
  second_identity_image_back: Yup.mixed()
    .nullable()
    .test(
      'is file uploaded',
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />,
      haveFiles
    ),
});
